import { IHttpService } from "../../core/service/HttpService";
import Constants from "../common/Constants";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import { ICourtCase } from "../model/CourtCase";
import { IInvalidatedCaseLawDocument } from "../model/InvalidatedCaseLawDocument";
import CaseLawDocumentMapper from "./CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "./CaseLawDocumentParamMapper";
import CourtCaseParamMapper from "./CourtCaseParamMapper";

export interface ICaseLawDocumentService {
  createCaseLawDocument(
    item: ICaseLawDocument,
    courtCases?: ICourtCase[],
    indexes?: number[],
    invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
  ): Promise<ICaseLawDocument>;
  updateCaseLawDocument(
    item: ICaseLawDocument,
    indexes: number[],
    courtCases?: ICourtCase[],
    invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
  ): void;
  archiveCaseLawDocument(caseLawDocumentId: number): Promise<ICaseLawDocument>;
  publishCaseLawDocument(caseLawDocumentId: number): Promise<ICaseLawDocument>;
  revertCaseLawDocumentStatus(
    caseLawDocumentId: number
  ): Promise<ICaseLawDocument>;
}

const CaseLawDocumentService = ({ httpService }): ICaseLawDocumentService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  return {
    async createCaseLawDocument(
      item: ICaseLawDocument,
      courtCases?: ICourtCase[],
      indexes?: number[],
      invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
    ) {
      const path = _http.buildPath(_baseUrl, Constants.endpointBasePath);
      const caseLawDocumentCreation = {
        caseLawDocument: CaseLawDocumentParamMapper(item),
        indexes: indexes,
        courtCases: courtCases?.map((elem) => CourtCaseParamMapper(elem)),
        invalidatedCaseLawDocuments: invalidatedCaseLawDocuments
      };
      const response = await _http.post(path, {
        form: false,
        params: caseLawDocumentCreation
      });
      const responseJSON = await _http.toJSON(response);
      return CaseLawDocumentMapper(responseJSON);
    },
    async updateCaseLawDocument(
      item: ICaseLawDocument,
      indexes: number[],
      courtCases?: ICourtCase[],
      invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
    ) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        item.id.toString()
      );
      const caseLawDocumentCreation = {
        caseLawDocument: CaseLawDocumentParamMapper(item),
        indexes: indexes,
        courtCases: courtCases?.map((elem) => CourtCaseParamMapper(elem)),
        invalidatedCaseLawDocuments: invalidatedCaseLawDocuments
      };
      const response = await _http.put(path, {
        form: false,
        params: caseLawDocumentCreation
      });
      return _http.toText(response);
    },

    async archiveCaseLawDocument(caseLawDocumentId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseLawDocumentId.toString(),
        "archive"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseLawDocumentMapper(responseJSON);
    },

    async publishCaseLawDocument(caseLawDocumentId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseLawDocumentId.toString(),
        "publish"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseLawDocumentMapper(responseJSON);
    },

    async revertCaseLawDocumentStatus(caseLawDocumentId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseLawDocumentId.toString(),
        "status-revert"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseLawDocumentMapper(responseJSON);
    }
  };
};

export default CaseLawDocumentService;
